import { toast } from "react-toastify";
import api from "./Interceptor";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const createAppointment = async (payload) => {
  try {
    const response = await api.post(
      `${BASE_URL}/appointment/create-appointment`,
      { ...payload, age: parseInt(payload.age) },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating appointment:", error);
    throw error?.response?.data || new Error("Unknown error");
  }
};

export const verifyPayment = async (
  payload,
  formData,
  setFormData,
  intialData,
  setLoading
) => {
  try {
    const res = await api.post(
      `${process.env.REACT_APP_BACKEND_URL}/payment/verify`,
      payload
    );

    if (res.data.success) {
      setFormData(intialData);
      setLoading(false);
      toast.success(
        `Your appointment has been successfully scheduled! We look forward to seeing you on ${new Date(
          formData.date
        ).toLocaleDateString()}. Thank you for choosing us!`,
        { autoClose: 5000 }
      );
    } else {
      setLoading(false);
      toast.error("Payment verification failed!");
    }
  } catch (error) {
    console.error("Payment verification error:", error);
    setLoading(false);
    toast.error("Error verifying payment.");
  }
};
